module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/settings/Layout.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2>Settings</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content wrapper-tabs wrapper-settings">\n<div class="row">\n<div class="col-md-12 col-lg-12">\n<div class="tabs-container">\n    <div class="tabs-left">\n        <ul class="nav nav-tabs">\n            <li class="';
 if (tab === 'company') { 
__p+=' active ';
 } 
__p+='">\n                <a href="#settings/company">Company Details</a>\n            </li>\n            ';
 if (!app.company.get('mppAdminId')) { 
__p+='\n            <li class="';
 if (tab === 'tax') { 
__p+=' active ';
 } 
__p+='">\n                <a href="#settings/tax">Tax Settings</a>\n            </li>\n            ';
 } 
__p+='\n            <li class="';
 if (tab === 'leave') { 
__p+=' active ';
 } 
__p+='">\n                <a href="#settings/leave">Leave Settings</a>\n            </li>\n            <li class="';
 if (tab === 'payment') { 
__p+=' active ';
 } 
__p+='">\n                <a href="#settings/payment">Payment Settings</a>\n            </li>\n            <li class="';
 if (tab === 'positions') { 
__p+=' active ';
 } 
__p+='">\n                <a href="#settings/positions">Positions</a>\n            </li>\n            <li class="';
 if (tab === 'payrollItems') { 
__p+=' active ';
 } 
__p+='">\n                <a href="#settings/payrollItems">Payroll Items</a>\n            </li>\n            <li class="';
 if (tab === 'notifications') { 
__p+=' active ';
 } 
__p+='">\n                <a href="#settings/notifications">Notifications</a>\n            </li>\n            ';
 if (!app.user.get('isMPPCustomer')) { 
__p+='\n            <li class="';
 if (tab === 'subscription') { 
__p+=' active ';
 } 
__p+='">\n                <a href="#settings/subscription">Subscription</a>\n            </li>\n            ';
 } 
__p+='\n            <li class="';
 if (tab === 'integrations') { 
__p+=' active ';
 } 
__p+='">\n                <a href="#settings/integrations">Integrations</a>\n            </li>\n        </ul>\n        <div class="tab-content">\n            <div class="js-company-setup-tab tab-pane">\n                <div class="js-company-setup panel-body"></div>\n            </div>\n            <div class="js-tax-tab tab-pane">\n                <div class="js-tax panel-body"></div>\n            </div>\n            <div class="js-leave-tab tab-pane">\n                <div class="js-leave panel-body"></div>\n            </div>\n            <div class="js-payment-tab tab-pane">\n                <div class="js-payment panel-body"></div>\n            </div>\n            <div class="js-position-tab tab-pane">\n                <div class="js-position panel-body"></div>\n            </div>\n            <div class="js-payroll-items-tab tab-pane">\n                <div class="js-payroll-items panel-body"></div>\n            </div>\n            <div class="js-notifications-tab tab-pane">\n                <div class="js-notifications panel-body"></div>\n            </div>\n            <div class="js-subscription-tab tab-pane">\n                <div class="js-subscription panel-body"></div>\n            </div>\n            <div class="js-integrations-tab tab-pane">\n                <div class="js-integrations panel-body"></div>\n            </div>\n            <div class="js-loading-tab tab-pane active">\n                <div class="panel-body">\n                    <div class="loader-wrapper">\n                        <div class="loader">\n                            '+
((__t=( require('commons/templates/Spinner.html')() ))==null?'':__t)+
'\n                        </div>\n                        <div class="clearfix"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n</div>\n</div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/settings/Layout.ejs
// module id = 837
// module chunks = 1